"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setContextMenuVisibility')(function setContextMenuVisibility(viewstate, isContextMenuShown) {
    viewstate.isContextMenuOpen = isContextMenuShown;
});
//# sourceMappingURL=setContextMenuVisibility.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/setContextMenuVisibility.js
// module id = 3401
// module chunks = 2 3